import React from 'react';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import { Box, Typography } from '@mui/material';
import { Map } from 'components/elements';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function AppointmentLocationMap({ address, locationAddress, locationPhoneNumber }) {
  const classes = useStyles();
  const { lat, lng, googleAddress, aptSuiteUnit } = locationAddress;
  return (
    <Box className={classes.addressWrapper} data-testid="appointment-map">
      <>
        <Map lat={lat} lng={lng} />
        <div className={classes.addressInfo} data-testid="appointment-physical">
          <Typography sx={{ fontWeight: 'bold' }} variant="body1" color="textSecondary" component="p">
            {address}
          </Typography>
          {googleAddress && (
            <Typography variant="body1" color="textSecondary" component="p">
              {googleAddress}
            </Typography>
          )}
          {aptSuiteUnit && (
            <Typography variant="body1" color="textSecondary" component="p">
              {aptSuiteUnit}
            </Typography>
          )}
          {locationPhoneNumber && (
            <Typography variant="body1" color="textSecondary" component="p">
              {locationPhoneNumber}
            </Typography>
          )}
        </div>
      </>
    </Box>
  );
}

AppointmentLocationMap.propTypes = {
  address: PropTypes.string.isRequired,
  locationPhoneNumber: PropTypes.string,
  locationAddress: PropTypes.objectOf(PropTypes.any),
};

AppointmentLocationMap.defaultProps = {
  locationAddress: null,
  locationPhoneNumber: null,
};

export default AppointmentLocationMap;
